import { Select } from "@/components/common/select/Select";
import styles from "./CarrouselSelectorMobile.module.scss";
import { CarrouselProps } from "../carrousel/Carrousel";

export type CarrouselSelectorMobileProps = {
  carrouselSelectedIndex: number;
  setCarrouselSelected: (value: CarrouselProps) => void;
  carrousel: CarrouselProps[];
};

export const CarrouselSelectorMobile = ({
  carrouselSelectedIndex,
  carrousel,
  setCarrouselSelected,
}: CarrouselSelectorMobileProps) => {
  return (
    <div className={styles.select}>
      <div className={styles.input}>
        <Select<CarrouselProps>
          initialIndex={carrouselSelectedIndex}
          setSelectedValue={setCarrouselSelected}
          selectOptions={carrousel}
          selectOptionsLabels={carrousel.map((a) => a.title)}
        />
      </div>
    </div>
  );
};
